import { Component } from "@theme/component";

class LinkedProducts extends Component {
  /** @type {HTMLSelectElement | null} */
  select = null;

  connectedCallback() {
    super.connectedCallback();

    this.select = this.querySelector("select");
    if (!this.select) return;

    this.select.addEventListener("change", this.#onChange);
  }

  disconnectedCallback() {
    this.select?.removeEventListener("change", this.#onChange);
    super.disconnectedCallback();
  }

  #onChange = (event) => {
    const url = event.target?.value;
    if (url) window.location.href = url;
  };
}

if (!customElements.get("linked-products")) {
  customElements.define("linked-products", LinkedProducts);
}
